import { createFileRoute } from '@tanstack/react-router';
import { AmforiSyncReport } from '@/app/(client)/network/-components/companyProfileTabs/integrations/report/AmforiSyncReport';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/integrations/history/$syncHistoryId/',
)({
  component: AmforiSyncReportRoute,
});

/** Own company only — a supplier's amfori link has no sync history to read, so
 *  this drill-down only ever opens off the caller's own Integrations tab. */
function AmforiSyncReportRoute() {
  const { syncHistoryId } = Route.useParams();
  return <AmforiSyncReport syncHistoryId={syncHistoryId} />;
}
